import { PreloadedDataInterface } from './preload';
import { setNamespace } from '../api';
import { setTranslations } from './translations';

/**
 * Bootstrap the application with the provided data.
 */
export default function bootstrap(data: PreloadedDataInterface) {
  setNamespace(data.api_namespace);
  setTranslations(data.translations);
}
